import React from 'react'
import PropTypes from 'prop-types'
import MultiSelect from "./MultiSelect"


const ColumnSelector = (props) => {
    const { columnList, hiddenColumns } = props;

    const options = columnList.map(
        column => ({
            'name': column.property,
            'checked': !hiddenColumns.includes(column.property),
            'title': column.header
        }))

    return (
        <MultiSelect options={options} {...props} />
    )
}

ColumnSelector.propTypes = {
    'columnList': PropTypes.array,
}


export default ColumnSelector


// WEBPACK FOOTER //
// ./src/modules/form/component/ColumnSelector.js